module.exports = __webpack_public_path__ + "img/special_01.c75ea1db.png";